// extracted by mini-css-extract-plugin
export default {"gridWrapper":"RecipientsModal_gridWrapper__QbUUu"};